// API 기본 URL을 현재 브라우저 호스트에 따라 동적으로 설정
export const getApiBaseUrl = (): string => {
  // 환경변수가 설정되어 있으면 사용 (프로덕션/Vercel)
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  const hostname = window.location.hostname;

  // localhost인 경우
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    const port = window.location.port;
    // 포트 80 또는 생략(nginx) → nginx 프록시 경유
    if (!port || port === '80' || port === '443') {
      return `${window.location.protocol}//${hostname}`;
    }
    // 개발 서버(3000 등) → 백엔드 직접 호출
    return 'http://localhost:4000';
  }

  // 공인 IP (배포 서버)
  if (hostname === '117.111.251.240') {
    return 'http://117.111.251.240:4000';
  }

  // 사설망 IP (192.168.x.x, 10.x.x.x, 172.16~31.x.x) — 개발 환경 LAN 접속
  if (/^(192\.168\.|10\.|172\.(1[6-9]|2[0-9]|3[01])\.)/.test(hostname)) {
    const port = window.location.port;
    // 포트 80 또는 생략(nginx) → nginx 프록시 경유 (같은 출처, CORS 불필요)
    if (!port || port === '80' || port === '443') {
      return `${window.location.protocol}//${hostname}`;
    }
    // 개발 서버(3000 등) → 백엔드 직접 호출
    return `http://${hostname}:4000`;
  }

  // 기본값: 현재 프로토콜 + 같은 호스트 사용 (Nginx 프록시)
  const protocol = window.location.protocol;
  return `${protocol}//${hostname}`;
};

export const API_BASE_URL = getApiBaseUrl();

// 이미지 URL을 현재 브라우저 호스트에 맞게 변환
export const convertImageUrl = (url: string): string => {
  if (!url) return url;

  // Supabase Storage 등 https URL은 변환 불필요
  if (url.startsWith('https://')) return url;

  // 이미 상대경로인 경우 현재 origin 붙여서 반환
  if (url.startsWith('/room_images/')) {
    return `${window.location.protocol}//${window.location.hostname}${url}`;
  }

  // localhost:xxxx 또는 IP:port URL → path만 추출해서 현재 origin으로 교체
  try {
    const parsed = new URL(url);
    return `${window.location.protocol}//${window.location.hostname}${parsed.pathname}`;
  } catch {
    return url;
  }
};
